import React from "react";
import { useRouteMatch } from "react-router";
import { Link } from "react-router-dom";
import { gql, useQuery } from "@apollo/client";

import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Tooltip,
  Fab,
  Container,
  Stack,
  Typography,
} from "@mui/material";
import { Plus as CreateIcon, Delete as DeleteIcon } from "mdi-material-ui";

import Layout from "components/common/Layout";

import CreateTemplateDialog from "components/template/CreateTemplateDialog";
import DeleteTemplateDialog from "components/template/DeleteTemplateDialog";

const QUERY = gql`
  query {
    templates {
      id
      name
      locked

      ...DeleteTemplateDialog_template
    }
  }

  ${DeleteTemplateDialog.fragments.template}
`;

export default function TemplatesPage() {
  const match = useRouteMatch();

  const { data, loading, refetch } = useQuery(QUERY, {
    fetchPolicy: "network-only",
  });
  if (loading) return <Layout.Loading />;

  return (
    <Container fixed>
      <Layout.Toolbar fixed>
        <Stack spacing={2} direction="row" alignItems="center">
          <CreateTemplateDialog>
            {({ open }) => (
              <Tooltip placement="top" title="Créer un template">
                <Fab onClick={open} size="small" color="primary">
                  <CreateIcon />
                </Fab>
              </Tooltip>
            )}
          </CreateTemplateDialog>

          <Typography variant="h4" color="primary" sx={{ flexGrow: 1 }}>
            Templates
          </Typography>
        </Stack>
      </Layout.Toolbar>

      <List>
        <DeleteTemplateDialog onTemplateDeleted={refetch}>
          {({ open }) =>
            data?.templates?.map((template) => (
              <ListItem
                key={template.id}
                dense
                divider
                button
                component={Link}
                to={`${match.url}/${template.id}`}
              >
                <ListItemText
                  primary={template.name || "Aucun nom"}
                  primaryTypographyProps={{
                    color: template.name ? undefined : "error",
                  }}
                />

                <ListItemSecondaryAction>
                  <IconButton
                    onClick={() => open(template)}
                    disabled={template.locked}
                  >
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))
          }
        </DeleteTemplateDialog>
      </List>
    </Container>
  );
}
